/** @jsx jsx */

import { css, jsx } from '@emotion/core';

export const Smiley = props => {
  const { styles, selected } = props;

  const { stroke, strokeWidth, ...$ } = styles;

  const { fill } = $;
  const transition = 'all 0.2s';

  return (
    <g>
      <path
        d="M6.32.2a6.12,6.12,0,1,0,6.11,6.12A6.12,6.12,0,0,0,6.32.2ZM8.64,4.05a.5.5,0,1,1-.5.5A.49.49,0,0,1,8.64,4.05ZM4,4.05a.5.5,0,1,1-.5.5A.49.49,0,0,1,4,4.05ZM6.32,9.7A3.75,3.75,0,0,1,2.7,7.15a.1.1,0,1,1,.19-.07A3.56,3.56,0,0,0,6.32,9.5,3.56,3.56,0,0,0,9.75,7.08.09.09,0,0,1,9.87,7a.12.12,0,0,1,.07.13A3.76,3.76,0,0,1,6.32,9.7Z"
        style={{
          fill: selected ? fill : 'transparent',
          transition,
        }}
      />
      <path
        d="M6.32,0a6.32,6.32,0,1,0,6.31,6.32A6.32,6.32,0,0,0,6.32,0Zm0,12.43a6.12,6.12,0,1,1,6.11-6.11A6.12,6.12,0,0,1,6.32,12.43Z"
        style={{
          fill: selected ? 'transparent' : fill,
          transition,
        }}
      />
      <path
        d="M9.87,7a.09.09,0,0,0-.12.07A3.56,3.56,0,0,1,6.32,9.5,3.56,3.56,0,0,1,2.89,7.08a.1.1,0,1,0-.19.07A3.75,3.75,0,0,0,6.32,9.7,3.76,3.76,0,0,0,9.94,7.14.12.12,0,0,0,9.87,7Z"
        style={{
          fill: selected ? 'transparent' : fill,
          transition,
        }}
      />
      <path
        d="M4,5a.5.5,0,1,0-.5-.49A.49.49,0,0,0,4,5Z"
        style={{
          fill: selected ? 'transparent' : fill,
          transition,
        }}
      />
      <path
        d="M8.64,5a.5.5,0,1,0-.5-.49A.49.49,0,0,0,8.64,5Z"
        style={{
          fill: selected ? 'transparent' : fill,
          transition,
        }}
      />
    </g>
  );

  return (
    <g id="open">
      <circle
        cx="6.32"
        cy="6.32"
        r="6.22"
        style={{
          ...(selected
            ? {
                fill: $.fill,
              }
            : {
                fill: 'none',
                stroke: $.fill,
                strokeMiterlimit: 10,
                strokeWidth: 0.2,
              }),
          transition: 'all 0.2s',
        }}
      />
      <path
        d="M9.84,7.11A3.68,3.68,0,0,1,6.32,9.6,3.67,3.67,0,0,1,2.79,7.11"
        style={{
          fill: 'none',
          stroke: selected ? '#fff' : $.fill,
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeWidth: 0.2,
          transition: 'all 0.2s',
        }}
      />
      <circle
        cx="4"
        cy="4.55"
        r="0.5"
        style={{
          fill: selected ? '#fff' : $.fill,
          transition: 'all 0.2s',
        }}
      />

      <circle
        cx="8.64"
        cy="4.55"
        r="0.5"
        style={{
          fill: selected ? '#fff' : $.fill,
          transition: 'all 0.2s',
        }}
      />
    </g>
  );
};
